module.exports = __webpack_public_path__ + "img/VP-UL_Overview-Rear_2.99ca3027.jpg";